import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FaBookOpen, FaHandHoldingUsd, FaHome } from 'react-icons/fa';
import './sidebar.css'
import { FaPeopleLine } from 'react-icons/fa6';
import { MdCircleNotifications, MdCloudUpload, MdNotificationsActive } from 'react-icons/md';
import { collapse } from '../redux/reducer/SideBarReducer';
const Sidebar = () => {
  const dispatch = useDispatch();
  const isCollapsed = useSelector((state) => state.sidebar.value);
  const handleSidebarToggle = () => {
    if (window.innerWidth < 768) {
      dispatch(collapse())
    }

  };
  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <nav>
        <ul>
          <li>
            <Link to="/dashboard/home" onClick={handleSidebarToggle}>
              <FaHome size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Home</span>}
            </Link>
          </li>
          <li>
            <Link to="/dashboard/upload-images" onClick={handleSidebarToggle}>
              <MdCloudUpload size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Images</span>}
            </Link>
          </li>
          {/* <li>
            <Link to="/dashboard/upload-directory" onClick={handleSidebarToggle}>
              <FaPeopleLine size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Directory</span>}
            </Link>
          </li> */}
          <li>
            <Link to="/dashboard/upload-notifications" onClick={handleSidebarToggle}>
              <MdNotificationsActive size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Notifications</span>}
            </Link>
          </li>

          <li>
            <Link to="/dashboard/upload-curriculum" onClick={handleSidebarToggle}>
              <FaBookOpen size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Curriculum</span>}
            </Link>

          </li>
          {/* <li>
            <Link to="/dashboard/upload-sale-rates" onClick={handleSidebarToggle}>
              <FaHandHoldingUsd size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Sale Rates</span>}
            </Link>
          </li> */}

        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar
